export function ScriptIcon() {
    return (
        <svg width="23" height="21" viewBox="0 0 23 21" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M9.3124 17.5376C8.8539 17.4545 2.19077 19.9045 2.19077 19.9045C3.80777 18.3592 4.65477 16.8481 4.45527 15.3843C2.60173 13.9977 1.48858 11.8359 1.43652 9.52175C1.4374 4.9875 5.9419 1.3125 11.4999 1.3125C17.0579 1.3125 21.5624 4.9875 21.5624 9.52175C21.5624 14.056 17.0579 17.7319 11.4999 17.7319C10.7664 17.7323 10.0343 17.6673 9.3124 17.5376V17.5376Z"
                stroke="#D5D6DA"
                strokeOpacity="0.6"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M13.207 4.16992C16.2477 4.79117 18.4999 7.03555 18.4999 9.71305C18.4501 11.4453 17.5602 13.0448 16.1147 14.0005"
                stroke="#D5D6DA"
                strokeOpacity="0.6"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
}
